export default {
  getCustomSearchResults: (state) => state.customSearchResults,
  getSearchVariants: (state) => state.searchVariants,
  getSelectedSearchVariant: (state) => state.selectedSearchVariant,
  getLoadingVariants: (state) => state.isLoading,
};
